import React, { useContext } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { UserContext } from "@src/context/user-context"
import { LocaleContext } from "@src/context/locale-context"
import SiteSearch from "@src/components/site-search-v2"
import NavPrimary from "@src/components/nav-site-primary"
import { Link } from "gatsby"
import Logo from "./reusable/svgs/logo"
import UserActions from "@src/components/content-user-flow-modal"
import NavbarHamburgerMenu from "./navbar/navbar-hamburger-menu"
import { FLAG, PHONE_NUMBER, EU_COUNTRIES } from "@src/utils/constants/locale"

const Brand = styled.div`
  & > a {
    display: inline-block;
    text-decoration: none;
    & > svg {
      display: inline-block;
    }
  }
  svg {
    min-width: 204px;
  }

  @media (max-width: 900px) {
    svg {
      min-width: 175px;
      max-width: 175px;
    }
  }

  @media (max-width: 400px) {
    svg {
      min-width: 155px;
      max-width: 155px;
    }
  }
`
const Search = styled(SiteSearch)``

const HeaderContainer = styled.header`
  position: sticky;
  z-index: ${props => props.theme.layers.siteHeader};
  top: 0;
  left: 0;
  right: 0;

  padding: 19px 56px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 131px;
  gap: 16px;

  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  background: #fff;

  @media (max-width: 1090px) {
    padding: 19px 3vw;
  }
  @media (max-width: 900px) {
    height: 87px;
  }
`

const Navbar = styled.div`
  display: flex;
  height: 57px;
  align-items: center;
  gap: 32px;

  @media (max-width: 900px) {
    gap: 8px;
  }
`

const NavbarSupport = styled.div`
  height: 21px;
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  @media (max-width: 900px) {
    display: none;
  }
`

const PhoneNumber = styled.div`
  color: #1f1f23;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 21px;
  letter-spacing: 0.5px;
`

const ContactUs = styled(Link)`
  color: #1f1f23;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0.5px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
  cursor: pointer;
`

const SiteHeader = ({ navItems }) => {
  const {
    user,
    signout,
    userFlowMode,
    showUserModal,
    setUserFlowMode,
    setShowUserModal,
  } = useContext(UserContext)
  let { country } = useContext(LocaleContext)

  if (EU_COUNTRIES.includes(country)) {
    country = "EU"
  }

  const flag = FLAG[country]
  const phoneNumber = PHONE_NUMBER[country]

  return (
    <>
      <HeaderContainer>
        <NavbarSupport>
          {phoneNumber && (
            <PhoneNumber>
              {flag}
              &nbsp;
              {phoneNumber}
            </PhoneNumber>
          )}
          <ContactUs to={"/contact/"}>Contact us</ContactUs>
        </NavbarSupport>
        <Navbar>
          <Brand>
            <Link to="/" title="10Adventures.com">
              <Logo />
            </Link>
          </Brand>
          <Search />
          <NavPrimary
            items={navItems}
            setUserFlowMode={setUserFlowMode}
            setShowUserModal={setShowUserModal}
            user={user}
            signout={signout}
          ></NavPrimary>
          <NavbarHamburgerMenu
            items={navItems}
            user={user}
            setUserFlowMode={setUserFlowMode}
            setShowUserModal={setShowUserModal}
            signout={signout}
          />
        </Navbar>
      </HeaderContainer>
      <UserActions
        defaultVisualMode={userFlowMode}
        $isOpen={showUserModal}
        setIsOpen={setShowUserModal}
      />
    </>
  )
}
SiteHeader.propTypes = {
  navItems: PropTypes.arrayOf(PropTypes.object),
  loginRequired: PropTypes.bool,
}
export default SiteHeader
